const $ = require("../../node_modules/jquery/dist/jquery.min");

module.exports = {
  init: () => {
    const trigger = $(".languagepicker-trigger");
    const dropdown = $(".languagepicker-dropdown");

    $(document).on("click", function(e) {
      if ($(e.target).closest(".languagepicker-dropdown").length === 0) {
        dropdown.removeClass("languagepicker-dropdown--active");
      }
    });

    trigger.on("click", () => {
      dropdown.toggleClass("languagepicker-dropdown--active");
      return false;
    });
  },
};
